import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=3b669dc8&scoped=true&"
import script from "./ThankYou.vue?vue&type=script&lang=ts&"
export * from "./ThankYou.vue?vue&type=script&lang=ts&"
import style0 from "./ThankYou.vue?vue&type=style&index=0&id=3b669dc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b669dc8",
  null
  
)

export default component.exports